if (!customElements.get('card-prize-product')) {
  customElements.define('card-prize-product',
    class CardPrizeProduct extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('click', this.submitForm);
      }
      submitForm = () => {
        const formSubmit = this.querySelector('.product-form__submit');
        if (formSubmit) {
          formSubmit.click();
        }
      }
    }
  );
}

